import { Component, OnInit, ViewChildren, QueryList, AfterViewInit, OnDestroy, ViewChild, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EFormService } from '../../../shared-components/e-forms/e-form.service';
import { EFormTab } from '../../../shared-components/e-forms/e-form-tab.model';
import { EFormPage } from '../../../shared-components/e-forms/e-form-page.model';
import { EFormColumn } from '../../../shared-components/e-forms/e-form-column.model';
import { EFormColumnComponent } from './e-form-column/e-form-column.component';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { TabsComponent } from '../../../shared-components/controls/tabs/tabs.component';
import { GeneralConfirmationComponent } from '../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { SharedService } from '../../../shared-components/shared.service';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { EFormAttachment } from '../../../shared-components/e-forms/e-form-attachment.model';
import { EFormDataObject } from '../../../shared-components/e-forms/e-formDataObject.model';
import { EFormControl } from '../../../shared-components/e-forms/e-form-control.model';
import { MergeFieldDialogComponent } from './merge-field-dialog/merge-field-dialog.component';
import { cloneDeep } from 'lodash';
import { EFormTemplate } from '../../../shared-components/e-forms/e-form-template.model';
import { EFormChangeHistory } from '../../../shared-components/e-forms/e-form-change-history.model';
import { EFormTemplateInUseWarningComponent } from './e-form-template-in-use-warning/e-form-template-in-use-warning.component';
import { EFormInstance } from '../../../shared-components/e-forms/e-form-instance.model';
import { EFormConfiguration, enmEFormViewModes } from '../../../shared-components/e-forms/e-form-config.model';
import { EFormDesignerService } from './e-form-designer.service';
import { EFormViewerModalComponent } from '../e-form-viewer/e-form-viewer-modal/e-form-viewer-modal.component';
import { CustomDesignPage } from '../../../admin360/customization/models/custom-design-page.model';
import { LoginService } from '../../../shared-modules/login/login.service';
import { take } from 'rxjs/operators';
import { EFormSurveyField } from '../e-form-survey-field.model';
import { EFormSurveyFieldCriticalValue } from '../e-form-survey-field-critical-value.model';
import { EFormRow } from '../e-form-row.model';
import { CustomizationFrameworkService } from '../../../shared-modules/customization-framework/customization-framework.service';
import { CdkDrag, CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { YearService } from '../../year/year.service';
import { EFormFormatWarningComponent } from './e-form-format-warning/e-form-format-warning.component';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'app-e-form-designer',
  templateUrl: './e-form-designer.component.html',
  styleUrls: ['./e-form-designer.component.css']
})
export class EFormDesignerComponent implements OnInit, AfterViewInit, OnDestroy {

  @Output() saveEvent = new EventEmitter<string>();
  @Output() closeEvent = new EventEmitter<boolean>();

  template: EFormTemplate;
  instance: EFormInstance;
  page: CustomDesignPage;
  eform: EFormDataObject;
  originalFormData: EFormDataObject;
  tabNames: string[] = [];
  selectedTab: EFormTab;
  selectedPage: EFormPage;
  selectedPageNumber: number;
  pageSelected: boolean;
  tabSelected: boolean;
  // selectedColumn: EFormColumn;
  selectedElementType: string;
  showSlideOutPanel = true;
  tabsLocked = false;
  attachmentChanges: EFormChangeHistory[] = [];
  config: EFormConfiguration;
  showBasePageCB: boolean;
  overwriteBasePage = false;

  @ViewChildren(EFormColumnComponent) columns: QueryList<EFormColumnComponent>;
  @ViewChild(TabsComponent) tabs: TabsComponent;
  linkedColumnDropLists: string[] = [];
  errors: ErrorList[] = [];
  subscriptions: Subscription[] = [];

  isFP = true;
  isLP = true;

  showSliderPanelValue = true;
  tabName = 'Controls';

  constructor(
    private eFormService: EFormService,
    private eFormDesignerService: EFormDesignerService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<EFormDesignerComponent>,
    private loginService: LoginService,
    private customizationFrameworkService: CustomizationFrameworkService,
    private yearService: YearService
  ) {
    this.config = data.config ? data.config : new EFormConfiguration();
    if (data && data.basePage) {
      this.overwriteBasePage = data.basePage;
      this.config.BasePage = data.basePage;
    }
  }

  ngOnInit() {
    if (!this.config) {
      this.config = new EFormConfiguration();
    }
    if (this.config.ViewMode == enmEFormViewModes.Template) {
      this.template = this.eFormService.selectedTemplate;
      this.config.IsSurvey = this.template.IsSurvey;
      this.config.IsMobile = this.template.IsMobile;
      this.config.Title = this.template.Name;
    }
    else if (this.config.ViewMode == enmEFormViewModes.Page) {
      this.page = this.eFormService.selectedDesignPage;
      this.config.CSTObjectID = this.page.ObjectID;
      this.config.Title = this.page.Name;
      this.config.IsDynamicWidth = true;
      if (this.loginService.LoginSettings.CustomizationDevMode) {
        this.showBasePageCB = true;
      }
      else {
        this.overwriteBasePage = false;
      }
      this.getCustomFieldMetadata();
    }
    else if (this.config.ViewMode == enmEFormViewModes.CustomPage) {
      this.getCustomFieldMetadata();
      this.config.IsDynamicWidth = true;
    }
    else if (this.config.ViewMode == enmEFormViewModes.FRMA) {

    }
    else {
      this.instance = this.eFormService.selectedInstance;
      this.config.IsSurvey = this.instance.IsSurvey;
      this.config.IsMobile = this.instance.IsMobile;
      this.config.Title = this.instance.Name;
    }
    if (this.config.IsMobile) {
      this.config.InformationalMessage = 'Because this template is available on the mobile application, additional columns may not be added, and each row is limited to two controls.';
    }
    this.eFormDesignerService.setUpForm(this.config);
    this.setUpCriticalChoices();
    this.eform = this.eFormService.selectedFormData;
    this.originalFormData = cloneDeep(this.eform);
    this.getTabs();
    this.subscriptions.push(this.eFormDesignerService.tabNameChangedEvent.subscribe(result => {
      this.getTabs();
    }));
    this.selectedPage = this.eFormDesignerService.selectedPage;
    this.selectedTab = this.eFormDesignerService.selectedTab;
    this.selectedPageNumber = this.getSelectedPageNumber();
    this.selectedElementType = this.eFormDesignerService.selectedElementType;
    this.subscriptions.push(this.eFormDesignerService.observableselectedElementChangedStream$.subscribe(o => {
      if (this.selectedTab != this.eFormDesignerService.selectedTab) {
        this.selectedTab = this.eFormDesignerService.selectedTab;
        const i = this.eform.Tabs.findIndex(t => t == this.selectedTab);
        this.tabs.selectedIndexChange(i);
      }
      this.selectedPage = this.eFormDesignerService.selectedPage;
      this.selectedPageNumber = this.getSelectedPageNumber();
      this.selectedElementType = this.eFormDesignerService.selectedElementType;

      switch (this.selectedElementType.toLowerCase()) {
        case 'page':
          this.pageSelected = true;
          this.tabSelected = false;
          this.isLastPage();
          this.isFirstPage();
          break;
        case 'tab':
          this.pageSelected = false;
          this.tabSelected = true;
          break;
        default:
          this.pageSelected = false;
          this.tabSelected = false;
          break;
      }
    }));

    if (!this.eFormService.databaseFields || this.eFormService.databaseFields.length == 0) {
      this.subscriptions.push(this.eFormService.getEFormDatabaseFields().subscribe(fields => {
        this.eFormService.databaseFields = fields;
        this.eFormService.observableDatabaseFields.next(fields);
      }));
    }
    if (!this.customizationFrameworkService.customDataFields || this.customizationFrameworkService.customDataFields.length == 0) {
      this.subscriptions.push(this.customizationFrameworkService.getCustomDataFields(this.yearService.defaultYear.Id, this.yearService.defaultYear.SiteYearId).subscribe(fields => {
        this.customizationFrameworkService.customDataFields = fields;
        this.customizationFrameworkService.observableFieldMetaDataRetrieved.next(fields);
      }));
    }
    this.eFormDesignerService.treeViewExpandAll(true);

    this.isLastPage();
    this.isFirstPage();

    this.eFormDesignerService.observableshowSliderPanelStream$.subscribe(Value => {
      this.showSliderPanelValue = Value;
    });
    this.eFormDesignerService.observableshowSliderPanelWidthStream$.subscribe(tabName => {
      this.tabName = tabName;
    });
    this.subscriptions.push(this.eFormDesignerService.observableSelectedPageChangedStream$.subscribe(o => {
      this.isLastPage();
      this.isFirstPage();
    }));
  }

  ngAfterViewInit() {

  }

  getCustomFieldMetadata() {
    if (this.config.CSTObjectID) {
      this.sharedService.getCustomDataFieldsByObjectID(this.config.CSTObjectID).pipe(take(1)).subscribe( results => {
        if (results) {
            this.eFormDesignerService.availableCSTFields = results;
            results.forEach(field => {
              if (!this.customizationFrameworkService.customDataFields.find(o => o.FieldName == field.FieldName)) {
                this.customizationFrameworkService.customDataFields.push(field);
              }
              this.customizationFrameworkService.observableFieldMetaDataRetrieved.next();
            });
        }
        else {
            this.eFormDesignerService.availableCSTFields = [];
        }
    });
    }
  }

  getSelectedPageNumber(): number {
    let pageIndex = this.selectedTab.Pages.findIndex(o => o.Name == this.selectedPage.Name &&  o.Id == this.selectedPage.Id);

    if (pageIndex == -1) {
      pageIndex = this.selectedTab.Pages.findIndex(o => o.Id == this.selectedPage.Id);
    }

    return pageIndex != -1 ? pageIndex + 1 : pageIndex;
  }

  checkForWarnings() {
    if (this.config.ViewMode == enmEFormViewModes.Template || this.config.ViewMode == enmEFormViewModes.Instance) {
      let showDropdownWarning: boolean = this.eFormDesignerService.masterControlList && this.eFormDesignerService.masterControlList.filter( control => control.ControlType == 'dropdown').length > 0;
      let showTextboxWarning: boolean = this.eFormDesignerService.masterControlList && this.eFormDesignerService.masterControlList.filter( control => control.ControlType == 'textbox').length > 0;

      if(showDropdownWarning || showTextboxWarning) {
        const warningDialog = this.dialog.open(EFormFormatWarningComponent, {
          disableClose: true,
          width: '500px',
          data: {
            showDropdownWarning: showDropdownWarning,
            showTextboxWarning: showTextboxWarning
          }
        });
    
        warningDialog.afterClosed().subscribe(confirmation => {
          if(confirmation) {
            this.saveClick(true);
          }
        });    
      }
      else {
        this.saveClick(true);
      }
    }
    else {
      this.saveClick(true);
    }
  }

  saveClick(closeOnSave: boolean) {
    this.validate();
    if (this.errors.length == 0) {
      // if (this.formType == 'template' && (this.config.ParentHandlesSave)) {
      if (this.config.ViewMode == enmEFormViewModes.Template) {
        if (this.template.InUse) {
          this.showTemplateInUseWarning(closeOnSave);
        }
        else {
          this.updateAttachments(() => {
            this.updateSurveyFields(() => {
              this.saveTemplate(closeOnSave);
            });
          });
        }
      }
      else if (this.config.ViewMode == enmEFormViewModes.Page) {
        this.saveDesignPage(closeOnSave);
      }
      else if (this.config.ViewMode == enmEFormViewModes.CustomPage) {
        this.updateAttachments(() => {
          this.saveCustomPage(closeOnSave);
        });
      }
      else if (this.config.ViewMode == enmEFormViewModes.FRMA) {
        this.updateAttachments(() => {
          this.saveFrmaPage(closeOnSave);
        });
      }
      else {
        this.updateAttachments(() => {
          this.updateSurveyFields(() => {
            this.saveInstance(closeOnSave);
          });
        });
      }
    }
  }

  showTemplateInUseWarning(closeOnSave: boolean) {
    const warningDialog = this.dialog.open(EFormTemplateInUseWarningComponent, {
      disableClose: true,
      width: '500px',
      data: {
        template: this.template
      }
    });

    warningDialog.afterClosed().subscribe(confirmation => {
      if (confirmation) {
        this.updateAttachments(() => {
          this.updateSurveyFields(() => {
            this.saveTemplate(closeOnSave);
          });
        });
      }
    });
  }

  saveTemplate(closeOnSave: boolean) {
    const selectedTemplate = this.eFormService.selectedTemplate;
    const eForm = cloneDeep(this.eform);
    const formControls = this.eFormService.getAllFormControls(eForm);
    formControls.forEach(c => c.Attachment = null);
    const formData = JSON.stringify(eForm);
    selectedTemplate.FormData = formData;

     if (this.config && this.config.ParentHandlesSave) {
    // if (this.config) {
      this.saveEvent.emit('save');
      if (closeOnSave) {
        if (this.dialogRef.close) {
          this.dialogRef.close(true);
        }
        this.closeEvent.emit(true);
      }
    }
    else {
      this.subscriptions.push(this.eFormService.saveTemplate(selectedTemplate).subscribe(result => {
        if (result) {
          this.template = result;
          if (selectedTemplate.InstancesExist) {
            this.saveChangeHistory(closeOnSave);
          }
          else {
            if (closeOnSave) {
              if (this.dialogRef.close) {
                this.dialogRef.close(true);
              }
              this.closeEvent.emit(true);
            }
            else {
              this.sharedService.showGoodSnackbar();
            }
          }
        }
        else {
          this.sharedService.showBadSnackbar();
        }
      }));
    }
  }

  saveInstance(closeOnSave: boolean) {
    if (!this.eFormService.selectedInstance.StudentIds) {
      this.eFormService.selectedInstance.StudentIds = [];
    }
    const selectedInstance = this.eFormService.selectedInstance;
    const eForm = cloneDeep(this.eform);
    const formControls = this.eFormService.getAllFormControls(eForm);
    formControls.forEach(c => c.Attachment = null);
    const formData = JSON.stringify(eForm);
    selectedInstance.FormData = formData;
    if (this.config && this.config.ParentHandlesSave) {
    // if (this.config) {
      this.saveEvent.emit('save');
    }
    else {
      this.subscriptions.push(this.eFormService.saveInstance(selectedInstance).subscribe(result => {
        if (result) {
          this.instance = result;
          this.saveChangeHistory(closeOnSave);
        }
        else {
          this.sharedService.showBadSnackbar();
        }
      }));
    }
  }

  saveDesignPage(closeOnSave: boolean) {
    const selectedDesignPage = this.eFormService.selectedDesignPage;
    const eForm = cloneDeep(this.eform);
    const formControls = this.eFormService.getAllFormControls(eForm);
    formControls.forEach(c => c.Attachment = null);
    // for(let i = 0; i < formControls.length; i++ ) {
    //   if(formControls[i].CustomFieldAllowControlToHandleOwnData) {
    //     formControls[i].CustomFieldAllowControlToHandleOwnData = false;
    //   }
    // };
    const formData = JSON.stringify(eForm);
    selectedDesignPage.FormData = formData;

    // if(this.config && this.config.ParentHandlesSave) {
    if (this.config) {
      this.saveEvent.emit(this.overwriteBasePage ? 'saveBasePage' : 'save');
      if (closeOnSave) {
        if (this.dialogRef.close) {
          this.dialogRef.close(true);
        }
        this.closeEvent.emit(true);
      }
    }
  }

  saveCustomPage(closeOnSave: boolean) {
    const eForm = cloneDeep(this.eform);
    const formControls = this.eFormService.getAllFormControls(eForm);
    formControls.forEach(c => c.Attachment = null);

    const formData = JSON.stringify(eForm);

    this.saveEvent.emit(formData);
    if (closeOnSave) {
      if (this.dialogRef.close) {
        this.dialogRef.close(true);
      }
      this.closeEvent.emit(true);
    }
  }

  saveFrmaPage(closeOnSave: boolean) {
    const eForm = cloneDeep(this.eform);
    const formControls = this.eFormService.getAllFormControls(eForm);
    formControls.forEach(c => c.Attachment = null);

    const formData = JSON.stringify(eForm);

    this.saveEvent.emit(formData);
    if (closeOnSave) {
      if (this.dialogRef.close) {
        this.dialogRef.close(true);
      }
      this.closeEvent.emit(true);
    }
  }

  validate() {
    this.errors = [];
    this.eform.Tabs.forEach(tab => {
      const tabname = tab.Name ? tab.Name : '';
      if (!tabname) {
        const index = this.eform.Tabs.findIndex(o => o == tab);
        let fieldName = 'Tab';
        if (index) {
          fieldName = fieldName + ' #' + (index + 1);
        }
        this.errors.push({
          fieldName: fieldName,
          fieldRef: null,
          errorMsg: 'Tabs names cannot be blank.',
          clickCallback: () => {
            this.selectTab(tab);
          }
        });
      }
      if (!tab.Pages || tab.Pages.length == 0) {
        this.errors.push({
          fieldName: tabname,
          fieldRef: null,
          errorMsg: 'This tab does not have any pages.',
          clickCallback: () => {
            this.selectTab(tab);
          }
        });
      }
      if (tab.ParentObjectId > 0 && !tab.Condition) {
        this.errors.push({
          fieldName: tabname,
          fieldRef: null,
          errorMsg: 'Parent object is selected without a condition.',
          clickCallback: () => {
            this.selectTab(tab);
          }
        });
      }
      tab.Pages.forEach(page => {
        const pageName = page.Name ? page.Name : '';
        if ((!page.Columns || page.Columns.length == 0) && (!page.Rows || page.Rows.length == 0)) {
          this.errors.push({
            fieldName: pageName,
            fieldRef: null,
            errorMsg: 'This page does not have any content.',
            clickCallback: () => {
              this.selectPage(page);
            }
          });
        }
        if (page.ParentObjectId > 0 && !page.Condition) {
          this.errors.push({
            fieldName: pageName,
            fieldRef: null,
            errorMsg: 'Parent object is selected without a condition.',
            clickCallback: () => {
              this.selectPage(page);
            }
          });
        }
        if (page.Columns && page.Columns.length > 0) {
          for (let c = 0; c < page.Columns.length; c++) {
            if (this.config.IsMobile) {
              if (this.checkColumnForTooManyControls(page.Columns[c])) {
                this.errors.push({
                  fieldName: pageName,
                  fieldRef: null,
                  errorMsg: 'Mobile forms cannot contain more than two controls per row.',
                  clickCallback: () => {
                    this.selectPage(page);
                  }
                });
                break;
              }
            }
            if (this.config.AllowColumnWidth) {
              if (page.Columns[c].FixedWidth && !page.Columns[c].Width) {
                this.errors.push({
                  fieldName: 'Column',
                  fieldRef: null,
                  errorMsg: 'Width is required.',
                  clickCallback: () => {
                    this.selectColumn(page.Columns[c]);
                  }
                });
              }
            }
          }
        }
      });
    });
    this.eFormDesignerService.masterControlList.forEach(control => {
      if (!control.Label && control.ControlType != this.eFormService.controlTypes.text && control.ControlType != this.eFormService.controlTypes.divider
        && control.ControlType != this.eFormService.controlTypes.verticalDivider) {
        this.errors.push({
          fieldName: this.eFormService.formatControlNameForErrors(control),
          fieldRef: null,
          errorMsg: 'Label is required.',
          clickCallback: () => {
            this.selectControl(control);
          }
        });
      }
      if (control.ParentObjectId > 0 && !control.Condition) {
        this.errors.push({
          fieldName: this.eFormService.formatControlNameForErrors(control),
          fieldRef: null,
          errorMsg: 'Parent object is selected without a condition.',
          clickCallback: () => {
            this.selectControl(control);
          }
        });
      }
      if (!control.CustomField && (control.ControlType == this.eFormService.controlTypes.buttons || control.ControlType == this.eFormService.controlTypes.dropdown || control.ControlType == this.eFormService.controlTypes.radioButtons)) {
        if (!control.DropdownOptions || control.DropdownOptions.length == 0) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'No choices are defined.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
        else if (control.ControlType == this.eFormService.controlTypes.dropdown) {
          if (control.DropdownOptions.find(o => !!o.CodeDescription) == null) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'Must have at least one non-blank choice.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
        }
        else if (control.ControlType == this.eFormService.controlTypes.radioButtons) {
          if (control.DropdownOptions.find(o => !o.CodeDescription) != null) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'Blank choices are not valid for radio buttons.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
          else if (control.DropdownOptions.length < 2) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'Radio buttons require at least two choices.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
          else if (!control.Value) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'No default choice is defined.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
        }
        else if (control.ControlType == this.eFormService.controlTypes.buttons) {
          if (control.DropdownOptions.find(o => !o.CodeDescription) != null) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'Blank choices are not valid for buttons.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
          else if (control.DropdownOptions.length < 2) {
            this.errors.push({
              fieldName: this.eFormService.formatControlNameForErrors(control),
              fieldRef: null,
              errorMsg: 'Buttons require at least two choices.',
              clickCallback: () => {
                this.selectControl(control);
              }
            });
          }
        }
      }
      else if (control.ControlType == this.eFormService.controlTypes.text) {
        if (!control.TextProvidedOnInstance && !control.Value) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'No text has been provided.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
        else if (control.TextProvidedOnInstance && !control.Instructions) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'No instructions have been provided.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
        // if (!control.Width) {
        //   this.errors.push({
        //     fieldName: this.eFormService.formatControlNameForErrors(control),
        //     fieldRef: null,
        //     errorMsg: 'Width must be selected.',
        //     clickCallback: () => {
        //       this.selectControl(control);
        //     }
        //   });
        // }
      }
      else if (control.ControlType == this.eFormService.controlTypes.image) {
        if (!control.Attachment && !control.AttachmentId) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'Image has not been provided.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
      }
      else if (control.ControlType == this.eFormService.controlTypes.linkToFile) {
        if ((!control.Attachment || !control.Attachment.FileDataBase64) && !control.TextProvidedOnInstance && !control.AttachmentId) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'File has not been provided.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
      }
      else if (control.ControlType == this.eFormService.controlTypes.attachment) {
        if (control.StoreLocation == 'student portfolio' && (!control.StuPortCategoryId || control.StuPortCategoryId <= 0)) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'Student Portfolio Category is required.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
        else if (control.StoreLocation == 'student digital content' && (!control.FormDocTypeId || control.FormDocTypeId <= 0)) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'Document Type is required.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
      }
      else if (control.ControlType == this.eFormService.controlTypes.note) {
        if (!control.Width) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'Width must be selected.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
        if (!control.NoteRows || control.NoteRows <= 0) {
          this.errors.push({
            fieldName: this.eFormService.formatControlNameForErrors(control),
            fieldRef: null,
            errorMsg: 'Height must be selected.',
            clickCallback: () => {
              this.selectControl(control);
            }
          });
        }
      }
      else if (control.CustomField && control.ControlType != 'component' && !control.CustomFieldName) {
        this.errors.push({
          fieldName: this.eFormService.formatControlNameForErrors(control),
          fieldRef: null,
          errorMsg: 'Custom Field is required.',
          clickCallback: () => {
            this.selectControl(control);
          }
        });
      }
    });
  }

  checkColumnForTooManyControls(col: EFormColumn): boolean {
    if (col.Rows && col.Rows.length > 0) {
      for (let i = 0; i < col.Rows.length; i++) {
        if (this.rowHasMoreThanTwoControls(col.Rows[i])) {
          return true;
        }
      }
    }
    else {
      return false;
    }
  }

  rowHasMoreThanTwoControls(row: EFormRow): boolean {
    let hasTooManyControls = false;
    if (row.Controls && row.Controls.length > 2) {
      hasTooManyControls = true;
    }
    else if (row.Columns && row.Columns.length > 0) {
      for (let i = 0; i < row.Columns.length; i++) {
        if (this.checkColumnForTooManyControls(row.Columns[i])) {
          hasTooManyControls = true;
          break;
        }
      }
    }
    return hasTooManyControls;
  }

  updateAttachments(_callback) {
    this.attachmentChanges = [];
    // const attachmentsToDelete: number[] = [];
    const newAttachments: EFormAttachment[] = [];
    this.eFormDesignerService.masterControlList.forEach(control => {
      // if (control.PreviousAttachmentId && control.PreviousAttachmentId != control.AttachmentId) {
      //   attachmentsToDelete.push(control.PreviousAttachmentId);
      // }
      if (!control.AttachmentId && control.Attachment && control.Attachment.FileDataBase64) {
        newAttachments.push(control.Attachment);
      }
    });
    // if (attachmentsToDelete.length > 0) {
    //   this.deleteAttachments(attachmentsToDelete);
    // }
    if (newAttachments.length > 0) {
      this.saveAttachments(newAttachments, _callback);
    }
    else {
      if (_callback) {
        _callback();
      }
    }
  }

  updateSurveyFields(_callback: Function) {
    const allControls = this.eFormDesignerService.masterControlList;
    const surveyFields: EFormSurveyField[] = [];
    if (this.config.IsSurvey) {
      allControls.forEach(c => {
        if (this.eFormService.inputControlTypes.includes(c.ControlType) && c.ControlType != this.eFormService.controlTypes.attachment) {
          const sf = new EFormSurveyField();
          sf.ID = c.SurveyFieldID;
          sf.ForTemplate = (this.config.ViewMode == enmEFormViewModes.Template);
          sf.TemplateID = this.config.ViewMode == enmEFormViewModes.Template ? this.template.ID : null;
          sf.InstanceID = this.config.ViewMode == enmEFormViewModes.Template ? null : this.instance.ID;
          sf.QuestionText = c.Label;
          sf.ControlType = c.ControlType;
          sf.IsRequired = c.IsRequired;
          sf.EFormControlID = c.Id;
          sf.CriticalValues = [];
          sf.IsSelectionControl = (c.ControlType == this.eFormService.controlTypes.dropdown || c.ControlType == this.eFormService.controlTypes.buttons || c.ControlType == this.eFormService.controlTypes.radioButtons || c.ControlType == this.eFormService.controlTypes.checkbox);
          if (c.ControlType == this.eFormService.controlTypes.checkbox) {
            sf.CriticalQuestion = c.IsCritical;
            if (c.IsCritical) {
              const critVal = new EFormSurveyFieldCriticalValue();
              critVal.SurveyFieldID = sf.ID;
              critVal.Value = 'checked';
              sf.CriticalValues.push(critVal);
            }
          }
          else if (c.ControlType == this.eFormService.controlTypes.dropdown || c.ControlType == this.eFormService.controlTypes.buttons || c.ControlType == this.eFormService.controlTypes.radioButtons) {
            sf.CriticalQuestion = true;
            c.IsCritical = true;
          }
          else {
            sf.CriticalQuestion = false;
          }

          c.DropdownOptions.forEach(val => {
            if (val.IsCritical) {
              const critVal = new EFormSurveyFieldCriticalValue();
              critVal.SurveyFieldID = sf.ID;
              critVal.Value = val.CodeDescription;
              sf.CriticalValues.push(critVal);
            }
          });
          surveyFields.push(sf);
        }
      });
      this.eFormService.saveEFormSurveyFields(surveyFields).pipe(take(1)).subscribe(fields => {
        fields.forEach( f => {
          const cnt = allControls.find(o => o.Id == f.EFormControlID);
          if (cnt) {
            cnt.SurveyFieldID = f.ID;
          }
        });
        if (_callback) {
          _callback();
        }
      });
    }
    else {
      if (_callback) {
        _callback();
      }
    }
  }

  selectControl(control: EFormControl) {
    this.eFormDesignerService.focusOnControl(control);
    this.eFormDesignerService.openPropertiesTab();
  }

  selectColumn(col: EFormColumn) {
    this.eFormDesignerService.focusOnColumn(col);
    this.eFormDesignerService.openPropertiesTab();
  }

  selectPage(page: EFormPage) {
    this.eFormDesignerService.focusOnPage(page);
    this.eFormDesignerService.openPropertiesTab();
  }

  selectTab(tab: EFormTab) {
    this.eFormDesignerService.focusOnTab(tab);
    this.eFormDesignerService.openPropertiesTab();
  }

  deleteAttachments(attachmentIds: number[]) {
    this.subscriptions.push(this.eFormService.deleteEFormAttachments(attachmentIds).subscribe(() => { }));
  }

  saveAttachments(attachments: EFormAttachment[], _callback) {
    this.subscriptions.push(this.eFormService.saveEFormAttachments(attachments).subscribe(result => {
      if (result && result.length == attachments.length) {
        for (let i = 0; i < result.length; i++) {
          const newAttachment = result[i];
          const oldAttachment = attachments[i];
          const control = this.eFormDesignerService.masterControlList.find(o => o.Attachment == oldAttachment);
          if (control) {
            control.AttachmentId = newAttachment.ID;
          }
        }
        if (_callback) {
          _callback();
        }
      }
      else {
        this.sharedService.showBadSnackbar();
      }
    }));
  }

  clearAttachments() {
    this.eFormDesignerService.masterControlList.forEach(control => {
      control.Attachment = null;
    });
  }

  cancelClick() {
    if (this.dialogRef.close) {
      this.dialogRef.close(false);
    }
    this.closeEvent.emit(false);
  }

  getTabs() {
    this.tabNames = [];
    this.eform.Tabs.forEach(tab => {
      this.tabNames.push(tab.Name);
    });
    if (this.tabNames.length > 0 && !this.selectedTab) {
      this.tabClick(this.tabNames[0]);
    }
  }

  tabClick(tabName: string) {
    const selectedTab = this.eform.Tabs.find(o => o.Name == tabName);

    if (this.selectedTab != selectedTab) {
      this.eFormDesignerService.focusOnTab(selectedTab);

      this.isFirstPage();
      this.isLastPage();
    }
  }

  // mat-tab only triggers on tab change so tabClick() will not focus property side panel on Tab if the user is already on that tab
  // added this call to always have property focus on tab click
  setFocusOnTabClick() {
    this.eFormDesignerService.focusOnTab(this.selectedTab);
  }

  previousClick() {
    // this.validate();
    if (this.errors.length == 0) {
      if (this.selectedTab && this.selectedPage) {
        let index = this.selectedTab.Pages.findIndex(o => o.Name == this.selectedPage.Name && o.Id == this.selectedPage.Id);
        if (index > 0) {
          index = index - 1;
          this.eFormDesignerService.focusOnPage(this.selectedTab.Pages[index]);
        }
        else {
          index = this.eform.Tabs.findIndex(o => o.Name == this.selectedTab.Name);
          if (index > 0) {
            index = index - 1;
            const newTab = this.eform.Tabs[index];
            const pageIndex = newTab.Pages.length - 1;
            if (pageIndex >= 0) {
              this.eFormDesignerService.focusOnPage(newTab.Pages[pageIndex]);
            }
            else {
              this.eFormDesignerService.focusOnTab(newTab);
            }
          }
        }
      }
    }
    this.isLastPage();
    this.isFirstPage();
  }

  nextClick() {
    // this.validate();
    if (this.errors.length == 0) {
      if (this.selectedTab && this.selectedPage) {
        let index = this.selectedTab.Pages.findIndex(o => o == this.selectedPage);
        const lastPageIndex = this.selectedTab.Pages.length - 1;
        if (index >= 0 && index < lastPageIndex) {
          index = index + 1;
          this.eFormDesignerService.focusOnPage(this.selectedTab.Pages[index]);
        }
        else {
          index = this.eform.Tabs.findIndex(o => o == this.selectedTab);
          const lastTabIndex = this.eform.Tabs.length - 1;
          if (index >= 0 && index < lastTabIndex) {
            index = index + 1;
            if (this.eform.Tabs[index].Pages.length > 0) {
              this.eFormDesignerService.focusOnPage(this.eform.Tabs[index].Pages[0]);
            }
            else {
              this.eFormDesignerService.focusOnTab(this.eform.Tabs[index]);
            }
          }
        }
      }
    }
    this.isLastPage();
    this.isFirstPage();
  }

  isFirstPage() {
    this.isFP = true;
    if (this.selectedPage && this.eform && this.eform.Tabs && this.eform.Tabs.length > 0 && this.eform.Tabs[0].Pages && this.eform.Tabs[0].Pages.length > 0) {
      const firstPage = this.eform.Tabs[0].Pages[0];
      if (this.selectedPage.Id != firstPage.Id) {
        this.isFP = false;
      }
    }
  }

  isLastPage() {
    this.isLP = true;
    if (this.selectedPage && this.eform && this.eform.Tabs && this.eform.Tabs.length > 0) {
      const lastTab = this.eform.Tabs[this.eform.Tabs.length - 1];
      if (lastTab.Pages && lastTab.Pages.length > 0) {
        const lastPage = lastTab.Pages[lastTab.Pages.length - 1];
        if (this.selectedPage.Id != lastPage.Id) {
          this.isLP = false;
        }
      }
    }
  }

  columnClick(column: EFormColumn) {

  }

  addRowClick() {
    this.eFormDesignerService.addRow(this.config.IsMobile);
  }

  addColumnClick() {
    this.eFormDesignerService.addColumn(this.config);
  }

  addControlClick() {
    this.eFormDesignerService.addControl(this.config);
  }

  addTabClick() {
    this.eFormDesignerService.addTab(this.config);
    this.isLastPage();
    this.isFirstPage();
  }

  addPageClick() {
    this.eFormDesignerService.addPage(this.config);
    this.isLastPage();
    this.isFirstPage();
  }

  deleteElementClick() {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'WARNING';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete this ' + this.selectedElementType + '?';
    deleteConfirmDialog.componentInstance.confirmEvent.subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.eFormDesignerService.deleteSelectedElement();
      }
    });
  }

  moveClick(direction: string) {
    this.eFormDesignerService.moveElement(direction);
  }

  previewClick() {
    const config = new EFormConfiguration();
    config.ViewMode = enmEFormViewModes.Template;
    config.Title = this.config.Title;
    if (this.config.ViewMode == enmEFormViewModes.Template) {
      config.Title = this.template.Name;
    }
    else if (this.config.ViewMode == enmEFormViewModes.Page) {
      config.Title = this.page.Name;
      config.ViewMode = enmEFormViewModes.Page;
    }
    else if (this.config.ViewMode == enmEFormViewModes.CustomPage) {
      config.ViewMode = enmEFormViewModes.CustomPage;
    }
    else if (this.config.ViewMode == enmEFormViewModes.FRMA) {
      config.ViewMode = enmEFormViewModes.FRMA;
    }
    else {
      config.Title = this.instance.Name;
    }
    config.AllowConditionalObjects = this.config.AllowConditionalObjects;
    config.AllowTabs = this.config.AllowTabs;
    config.AllowPages = this.config.AllowPages;
    config.AllowInstanceSpecificText = this.config.AllowInstanceSpecificText;
    const previewDialog = this.dialog.open(EFormViewerModalComponent, {
      disableClose: true,
      height: '100vh',
      minWidth: '900px',
      data: {
        config: config
      }
    });
  }

  mobilePreviewClick() {
    const config = new EFormConfiguration();
    config.ViewMode = enmEFormViewModes.Template;

    if (this.config.ViewMode == enmEFormViewModes.Template) {
      config.Title = this.template.Name;
    }
    else if (this.config.ViewMode == enmEFormViewModes.Page) {
      config.Title = this.page.Name;
    }
    else if (this.config.ViewMode == enmEFormViewModes.CustomPage) {

    }
    else {
      config.Title = this.instance.Name;
    }
    config.InformationalMessage = 'This view approximates what the form will look like on a mobile device. The actual form may look different, depending on the device and operating system.';
    config.IsMobilePreview = true;
    config.AllowConditionalObjects = this.config.AllowConditionalObjects;
    config.AllowTabs = this.config.AllowTabs;
    config.AllowPages = this.config.AllowPages;
    config.AllowInstanceSpecificText = this.config.AllowInstanceSpecificText;
    const previewDialog = this.dialog.open(EFormViewerModalComponent, {
      disableClose: true,
      height: '100vh',
      width: '390px',
      data: {
        config: config
      }
    });
  }

  displayMergeFields() {
    const mergeFieldDialog = this.dialog.open(MergeFieldDialogComponent, {
      height: '80vh',
      minWidth: '200px',
      hasBackdrop: false,
      disableClose: true,
      data: {
        config: this.config,
        allowStudentSpecificMergeFields: this.data.allowStudentSpecificMergeFields,
        allowAdultSpecificMergeFields: this.data.allowAdultSpecificMergeFields
      }
    });
  }

  ngOnDestroy() {
    this.eFormDesignerService.closeMergeFieldWindow();
  }

  saveChangeHistory(closeOnSave: Boolean) {
    const changes: EFormChangeHistory[] = [];
    const oldFields = this.eFormService.getAllFormControls(this.originalFormData);
    const newFields = this.eFormDesignerService.masterControlList;
    const oldTabs = this.originalFormData.Tabs;
    const newTabs = this.eform.Tabs;
    oldTabs.forEach(oldTab => {
      const newTab = newTabs.find(o => o.Id == oldTab.Id);
      if (newTab) {
        if (newTab.Name != oldTab.Name) {
          changes.push(this.getElementChange(oldTab.Id, oldTab.Name, 'Name', 'Tab', 'English', oldTab.Name, newTab.Name));
        }
        if (oldTab.ParentObjectId != newTab.ParentObjectId) {
          let oldVal = '';
          let newVal = '';
          if (oldTab.ParentObjectId > 0) {
            const oldParent = oldFields.find(o => o.Id == oldTab.ParentObjectId);
            if (oldParent) {
              oldVal = this.eFormService.formatControlName(oldParent);
            }
            const newParent = newFields.find(o => o.Id == newParent.Id);
            if (newParent) {
              newVal = this.eFormService.formatControlName(newParent);
            }
          }
          changes.push(this.getElementChange(oldTab.Id, oldTab.Name, 'Conditional Object', 'Tab', 'English', oldVal, newVal));
        }
        if (oldTab.Condition != newTab.Condition) {
          const oldVal = oldTab.Condition ? oldTab.Condition.toString() : '';
          const newVal = newTab.Condition ? newTab.Condition.toString() : '';
          changes.push(this.getElementChange(oldTab.Id, oldTab.Name, 'Condition', 'Tab', 'English', oldVal, newVal));
        }
        oldTab.Pages.forEach(oldPage => {
          const newPage = newTab.Pages.find(o => o.Id == oldPage.Id);
          if (newPage) {
            if (newPage.Name != oldPage.Name) {
              changes.push(this.getElementChange(oldPage.Id, oldPage.Name, 'Name', 'Page', 'English', oldPage.Name, newPage.Name));
            }
            if (oldPage.ParentObjectId != newPage.ParentObjectId) {
              let oldVal = '';
              let newVal = '';
              if (oldPage.ParentObjectId > 0) {
                const oldParent = oldFields.find(o => o.Id == oldPage.ParentObjectId);
                if (oldParent) {
                  oldVal = this.eFormService.formatControlName(oldParent);
                }
                const newParent = newFields.find(o => o.Id == newParent.Id);
                if (newParent) {
                  newVal = this.eFormService.formatControlName(newParent);
                }
              }
              changes.push(this.getElementChange(oldPage.Id, oldPage.Name, 'Conditional Object', 'Page', 'English', oldVal, newVal));
            }
            if (oldPage.Condition != newPage.Condition) {
              const oldVal = oldPage.Condition ? oldPage.Condition.toString() : '';
              const newVal = newPage.Condition ? newPage.Condition.toString() : '';
              changes.push(this.getElementChange(oldPage.Id, oldPage.Name, 'Condition', 'Page', 'English', oldVal, newVal));
            }
          }
          else {
            changes.push(this.getElementChange(oldPage.Id, oldPage.Name, 'Conditional Object', 'Page', 'English', oldPage.Name, ''));
          }
        });
        newTab.Pages.forEach(newPage => {
          const oldPage = oldTab.Pages.find(o => o.Id == newPage.Id);
          if (!oldPage) {
            changes.push(this.getElementChange(newPage.Id, newPage.Name, 'Conditional Object', 'Page', 'English', '', newPage.Name));
          }
        });
      }
      else {
        changes.push(this.getElementChange(oldTab.Id, oldTab.Name, 'Conditional Object', 'Tab', 'English', oldTab.Name, ''));
      }
    });
    newTabs.forEach(newTab => {
      const oldTab = oldTabs.find(o => o.Id == newTab.Id);
      if (!oldTab) {
        changes.push(this.getElementChange(newTab.Id, newTab.Name, 'Conditional Object', 'Tab', 'English', '', newTab.Name));
      }
    });
    oldFields.forEach(oldField => {
      const fieldLabel = this.eFormService.formatControlName(oldField);
      const newField = newFields.find(o => o.Id == oldField.Id);
      if (newField) {
        const newFieldLabel = this.eFormService.formatControlName(newField);
        if (oldField.Label != newField.Label) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Label', 'Control', 'English', oldField.Label, newField.Label));
        }
        if (!!oldField.IsRequired != !!newField.IsRequired) {
          const oldVal = oldField.IsRequired ? oldField.IsRequired.toString() : '';
          const newVal = newField.IsRequired ? newField.IsRequired.toString() : '';
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Required', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.ControlType == this.eFormService.controlTypes.text && oldField.Value != newField.Value) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Text', 'Control', 'English', oldField.Value, newField.Value));
        }
        if (oldField.Width != newField.Width) {
          const oldVal = oldField.Width ? oldField.Width.toString() : '';
          const newVal = newField.Width ? newField.Width.toString() : '';
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Width', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.Indent != newField.Indent) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Indent', 'Control', 'English', oldField.Indent ? oldField.Indent.toString() : '', newField.Indent.toString()));
        }
        if (oldField.NoteRows != newField.NoteRows) {
          const oldVal = oldField.NoteRows ? oldField.NoteRows.toString() : '';
          const newVal = newField.NoteRows ? newField.NoteRows.toString() : '';
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Height in Rows ', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.ParentObjectId != newField.ParentObjectId) {
          let oldVal = '';
          let newVal = '';
          if (oldField.ParentObjectId > 0) {
            const oldParent = oldFields.find(o => o.Id == oldField.ParentObjectId);
            if (oldParent) {
              oldVal = this.eFormService.formatControlName(oldParent);
            }
            const newParent = newFields.find(o => o.Id == newParent.Id);
            if (newParent) {
              newVal = this.eFormService.formatControlName(newParent);
            }
          }
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Conditional Object', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.Condition != newField.Condition) {
          const oldVal = oldField.Condition ? oldField.Condition.toString() : '';
          const newVal = newField.Condition ? newField.Condition.toString() : '';
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Condition', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.TextProvidedOnInstance != newField.TextProvidedOnInstance) {
          let type = 'Text provided when e-Form is created';
          if (oldField.ControlType == this.eFormService.controlTypes.linkToFile) {
            type = 'File provided when e-Form is created';
          }
          const oldVal = oldField.TextProvidedOnInstance ? oldField.TextProvidedOnInstance.toString() : '';
          const newVal = newField.TextProvidedOnInstance ? newField.TextProvidedOnInstance.toString() : '';
          changes.push(this.getElementChange(oldField.Id, fieldLabel, type, 'Control', 'English', oldVal, newVal));
        }
        if (oldField.Instructions != newField.Instructions) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Instructions', 'Control', 'English', oldField.Instructions, newField.Instructions));
        }
        if (oldField.InstructionFormat != newField.InstructionFormat) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Instruction Format', 'Control', 'English', oldField.InstructionFormat == 'richText' ? 'Rich text' : 'Plain text', newField.InstructionFormat == 'richText' ? 'Rich text' : 'Plain text'));
        }
        if (oldField.LinkedDBField != newField.LinkedDBField) {
          let oldVal = '';
          let newVal = '';
          if (oldField.LinkedDBField > 0) {
            const oldDBField = this.eFormService.databaseFields.find(o => o.ID == oldField.LinkedDBField);
            if (oldDBField) {
              oldVal = oldDBField.FieldName;
            }
          }
          if (newField.LinkedDBField > 0) {
            const newDBField = this.eFormService.databaseFields.find(o => o.ID == newField.LinkedDBField);
            if (newDBField) {
              newVal = newDBField.FieldName;
            }
          }
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Location to Save Data', 'Control', 'English', oldVal, newVal));
        }
        if ((oldField.ControlType == this.eFormService.controlTypes.image || oldField.ControlType == this.eFormService.controlTypes.linkToFile) && oldField.AttachmentId != newField.AttachmentId) {
          const propertyName = oldField.ControlType == this.eFormService.controlTypes.image ? 'Image' : 'File';
          let oldFile = '';
          let newFile = '';
          if (oldField.Attachment) {
            oldFile = oldField.Attachment.OriginalFileName;
          }
          if (newField.Attachment) {
            newFile = newField.Attachment.OriginalFileName;
          }
          changes.push(this.getElementChange(oldField.Id, fieldLabel, propertyName, 'Control', 'English', oldFile, newFile));
        }
        if (oldField.StoreLocation != newField.StoreLocation) {
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Store Attachment', 'Control', 'English', oldField.StoreLocation, newField.StoreLocation));
        }
        if (oldField.StuPortCategoryId != newField.StuPortCategoryId) {
          let oldVal = '';
          let newVal = '';
          if (oldField.StuPortCategoryId > 0) {
            const oldCat = this.eFormDesignerService.studentPortfolioCategories.find(o => o.Id == oldField.StuPortCategoryId.toString());
            if (oldCat) {
              oldVal = oldCat.CodeDescription;
            }
          }
          if (newField.StuPortCategoryId > 0) {
            const newCat = this.eFormDesignerService.studentPortfolioCategories.find(o => o.Id == newField.StuPortCategoryId.toString());
            if (newCat) {
              newVal = newCat.CodeDescription;
            }
          }
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Student Portfolio Category', 'Control', 'English', oldVal, newVal));
        }
        if (oldField.FormDocTypeId != newField.FormDocTypeId) {
          let oldVal = '';
          let newVal = '';
          if (oldField.FormDocTypeId > 0) {
            const oldDoc = this.eFormDesignerService.documentTypes.find(o => o.Id == oldField.FormDocTypeId.toString());
            if (oldDoc) {
              oldVal = oldDoc.CodeDescription;
            }
          }
          if (newField.FormDocTypeId > 0) {
            const newDoc = this.eFormDesignerService.studentPortfolioCategories.find(o => o.Id == newField.FormDocTypeId.toString());
            if (newDoc) {
              newVal = newDoc.CodeDescription;
            }
          }
          changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Document Type', 'Control', 'English', oldVal, newVal));
        }
        oldField.DropdownOptions.forEach(opt => {
          if (!newField.DropdownOptions.find(o => o.CodeDescription == opt.CodeDescription)) {
            changes.push(this.getElementChange(oldField.Id, fieldLabel, 'Choices', 'Control', 'English', opt.CodeDescription, ''));
          }
        });
        newField.DropdownOptions.forEach(opt => {
          if (!oldField.DropdownOptions.find(o => o.CodeDescription == opt.CodeDescription)) {
            changes.push(this.getElementChange(newField.Id, newFieldLabel, 'Choices', 'Control', 'English', '', opt.CodeDescription));
          }
        });
      }
      else {
        changes.push(this.getElementChange(oldField.Id, fieldLabel, this.eFormService.formatControlType(oldField.ControlType), 'Control', 'English', this.eFormService.formatControlName(oldField), ''));
      }
    });
    newFields.forEach(newField => {
      const oldField = oldFields.find(o => o.Id == newField.Id);
      if (!oldField) {
        changes.push(this.getElementChange(newField.Id, this.eFormService.formatControlName(newField), this.eFormService.formatControlType(newField.ControlType), 'Control', 'English', '', this.eFormService.formatControlName(newField)));
      }
    });
    if (changes.length > 0) {
      if (this.config.ViewMode == enmEFormViewModes.Template) {
        this.subscriptions.push(this.eFormService.saveTemplateChangeHistory(changes).subscribe(result => {
          if (closeOnSave) {
            if (this.dialogRef.close) {
              this.dialogRef.close(true);
            }
            this.closeEvent.emit(true);
          }
          else {
            this.originalFormData = cloneDeep(this.eform);
            this.sharedService.showGoodSnackbar();
          }
        }));
      }
      else {
        this.subscriptions.push(this.eFormService.saveInstanceChangeHistory(changes).subscribe(result => {
          if (closeOnSave) {
            if (this.dialogRef.close) {
              this.dialogRef.close(true);
            }
            this.closeEvent.emit(true);
          }
          else {
            this.originalFormData = cloneDeep(this.eform);
            this.sharedService.showGoodSnackbar();
          }
        }));
      }
    }
    else {
      if (closeOnSave) {
        if (this.dialogRef.close) {
          this.dialogRef.close(true);
        }
        this.closeEvent.emit(true);
      }
    }
  }

  getElementChange(id: number, fieldName: string, property: string, objectType: string, language: string, oldValue: string, newValue: string): EFormChangeHistory {
    const newChange = new EFormChangeHistory();
    if (this.config.ViewMode == enmEFormViewModes.Template) {
      newChange.TemplateId = this.template.ID;
      newChange.TemplateAuditId = this.template.TemplateAuditId;
    }
    else {
      newChange.InstanceId = this.instance.ID;
      newChange.InstanceAuditId = this.instance.InstanceAuditId;
    }
    newChange.ObjectType = objectType;
    newChange.FieldId = id;
    newChange.FieldName = fieldName;
    newChange.Property = property;
    newChange.Language = language;
    newChange.OldValue = oldValue;
    newChange.NewValue = newValue;
    return newChange;
  }

  setUpCriticalChoices() {
  //   if (this.config.IsSurvey) {
  //     if (this.formType == 'template') {
  //       this.eFormService.getSurveyQuestionsByTemplateID(this.template.ID).pipe(take(1)).subscribe(surveyFields => {
  //         this.template.SurveyFields = surveyFields;
  //         this.eFormDesignerService.setUpCriticalChoices(surveyFields);
  //       });
  //     }
  //     else {
  //       this.eFormService.getSurveyQuestionsByInstanceID(this.instance.ID).pipe(take(1)).subscribe(surveyFields => {
  //         this.instance.SurveyFields = surveyFields;
  //         this.eFormDesignerService.setUpCriticalChoices(surveyFields);
  //       });
  //     }
  //   }
  }

  columnDropped(event: CdkDragDrop<EFormColumn[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(this.selectedPage.Columns, event.previousIndex, event.currentIndex);
    }
  }

  columnPredicate(item: CdkDrag<EFormColumn>) {
    if (this.selectedPage && this.selectedPage.Columns && this.selectedPage.Columns.find(o => o == item.data)) {
      return true;
    }
    else {
      return false;
    }
  }

  dragStart() {
    this.eFormDesignerService.dragStart();
  }

  dragEnd() {
    this.eFormDesignerService.dragEnd();
  }

}
